import { ISearchPageContext } from "@/search/NewSearchPageMVP/provider/SearchPageProvider";

export const searchPageV2ContextInitialValue: ISearchPageContext = {
  getters: {
    searchResults: [],
    isSearchLoading: true,
    validQueryParams: {},
    readingSkills: [],
    sendAdminContentSettings: false,
    searchParams: new URLSearchParams(""),
    searchResponse: {
      results: [],
      search_id: "",
      total_result_count: {
        value: 0,
        relation: "",
      },
    },
    taxonomyResults: [],
    isLoadingTaxonomyData: false,
    selectedTaxonomyTags: {},
    taxonomyTagsSlugs: [],
  },
  handlers: {
    getAllSearchParams: () => [],
    getSearchParamValues: () => [],
    setSearchParamValue: () => null,
    hasSearchParamValue: () => false,
    toggleSearchParamValue: () => null,
    deleteSearchParamValues: () => null,
    setSendAdminContentSettings: () => null,
    setSelectedTaxonomyTags: () => null,
    setTaxonomyTagsSlugs: () => null,
  },
};
